var map = {
	"./blankIcon.svg": 1599,
	"./csvIcon.svg": 1974,
	"./docIcon.svg": 1975,
	"./htmlIcon.svg": 1976,
	"./pdfIcon.svg": 1977,
	"./pptxIcon.svg": 1978,
	"./videoIcon.svg": 1598,
	"./xlsIcon.svg": 1979
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1973;